export default "__VITE_ASSET__6605d846__"